module.exports = __webpack_public_path__ + "static/media/anc5ru.b0bd203f.pdf";